import { TimelineItem } from '../state/types'

/**
 * Every declaration this run WROTE to, newest-first-in-path-order, primary first.
 *
 * `session_complete` reports a single `transitOperationId`, so a run that produced several drafts
 * (one T1 per wagon on a groupage SMGS, or two identical declarations on request) leaves the rest
 * unreachable by click. They are recoverable though: every draft-scoped write names its declaration.
 * The current service sends it as `declarationId` on the step (the same pattern as its own tid
 * backstop, `activity.TID_IN_PATH` in tardek-agent-sdk-copilot); an OLDER service's summaries were
 * `"<METHOD> <path>"` with the id as a path segment, and those are still read the old way.
 *
 * Reads are excluded on purpose. A GET only means the agent looked at a declaration — in the
 * reported case it inspected two flawed drafts and deliberately left them alone, and offering
 * those as results would be actively misleading. Restricting to writes also means the semantics
 * are honestly "declarations this run changed", which is what an operator wants to click through,
 * rather than "declarations created" — a distinction the wire does not let us make.
 */
const TID_IN_PATH = /\/v[23]\/transit-operation\/(\d+)/
const WRITE = /^(POST|PUT|PATCH) \//

export function draftIdsFromTimeline(items: TimelineItem[], primaryId: number): number[] {
  const ids: number[] = []
  const add = (id: number) => { if (id > 0 && !ids.includes(id)) ids.push(id) }

  add(primaryId)          // the wire's own answer stays first-class and first in the list
  items.forEach((item) => {
    if (item.kind !== 'tool') return
    if (item.activity) {
      if (item.activity.type === 'api' && item.activity.methodClass === 'write' && item.activity.declarationId) {
        add(item.activity.declarationId)
      }
      return
    }
    if (!WRITE.test(item.summary)) return
    const match = TID_IN_PATH.exec(item.summary)
    if (match) add(Number(match[1]))
  })
  return ids
}
